import {
  Box,
  Grid,
  createTheme,
  ThemeProvider,
  Menu,
  Stack,
  Select,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { format } from "date-fns";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";

import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import MenuItem from "@mui/material/MenuItem";
import MUIDataTable from "mui-datatables";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

import { useNavigate } from "react-router-dom";

import ReactQuill from "react-quill";
import HeaderCraneBooking from "./HeaderCraneBooking";
import { driverLeaveApis, craneBooking } from "../../Data/axios";
import { getUserInfo } from "../../Data/UserData";
import config from "../../Data/AuthUser";
import StatusAlert from "../../StatusAlertList/StatusAlert";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const TransitionRight = React.forwardRef(function TransitionRight(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

function CraneBooking() {
  const [radioButton, setRadioButton] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [uploadFile, setUploadFile] = useState(null);
  const [descriptionRemark, setDescriptionRemark] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openRemark, setOpenRemark] = React.useState(false);
  const [openAddModal, setOpenAddModal] = React.useState(false);

  // New state variables for crane booking form
  const [formData, setFormData] = useState({
    booking_id: "",
    user_id: "",
    Crane_owner_id: "",
    trip_id: "",
    driver_name: "",
    driver_number: "",
    vehicle_id: "",
    note: "",
    lat: "",
    lng: "",
    address: "",
    distance: "",
    total_amount: "",
    first_payment: "",
    first_payment_time: "",
    booking_status: "",
  });

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");

  const [name, setName] = React.useState("");

  const [price, setPrice] = React.useState("");
  const [discount, setDiscount] = React.useState("");
  const [call, setCall] = React.useState("");
  const [color, setColor] = useState("#ff0000");
  const [post, setPost] = React.useState("");

  const [validity, setValidity] = React.useState("");

  const [userType, setUserType] = useState("");
  const [visibility, setVisibility] = useState("");

  const [articalData, setArticalData] = useState([]);
  const [selectCategory, setSelectCategory] = useState("");
  const [selectedRadio, setSelectedRadio] = useState("Client");

  const [statusType, setStatusType] = useState([]);
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };
  useEffect(() => {
    if (selectedRadio === "App User") {
      setRadioButton(true);
    } else {
      setRadioButton(false);
    }
  }, [selectedRadio]);
  function formatDate(isoString) {
    const date = new Date(isoString);

    // Get the date components
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    // Get the time components
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // The hour '0' should be '12'

    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  }

  const handleFileChange = (event) => {
    setUploadFile(event.target.files[0]);
  };

  const handleUpdateDetails = () => {
    setOpenRemark(true);
  };
  const navigate = useNavigate();

  const [description, setDescription] = useState("");

  // Handler functions for Add Crane Booking modal
  const handleOpenAddModal = () => {
    // Auto-generate booking ID
    const bookingId = `CB${Date.now()}${Math.floor(Math.random() * 1000)}`;
    setFormData((prev) => ({
      ...prev,
      booking_id: bookingId,
    }));
    setOpenAddModal(true);
  };

  const handleCloseAddModal = () => {
    setOpenAddModal(false);
    setFormData({
      booking_id: "",
      user_id: "",
      Crane_owner_id: "",
      trip_id: "",
      driver_name: "",
      driver_number: "",
      vehicle_id: "",
      note: "",
      lat: "",
      lng: "",
      address: "",
      distance: "",
      total_amount: "",
      first_payment: "",
      first_payment_time: "",
      booking_status: "",
    });
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmitCraneBooking = async () => {
    try {
      const formDataToSend = new FormData();

      // Append each form field to FormData
      Object.keys(formData).forEach((key) => {
        if (formData[key] !== undefined && formData[key] !== null) {
          formDataToSend.append(key, formData[key]);
        }
      });

      const result = await craneBooking.add(formDataToSend);

      if (result.success) {
        showAlert("Crane booking added successfully", "success");
        handleCloseAddModal();
        getData();
      } else {
        showAlert(result.message || "Failed to add crane booking", "error");
      }
    } catch (error) {
      console.error("Error adding crane booking:", error);
      showAlert("Failed to add crane booking", "error");
    }
  };

  const handleOpenMenu = (id) => {
    setOpenMenuId(id);
  };
  const handleViewMore = async () => {
    const rowData = await driverLeaveApis.leaveViewMoreId(openMenuId);
    navigate(`/crane_booking/${openMenuId}`, { state: rowData });
  };

  const [openMenuId, setOpenMenuId] = useState(null);
  const userInfoString = localStorage.getItem("user-info");
  // Parse the string into an object
  const userInfo = JSON.parse(userInfoString);
  const handleAllData = () => {
    setOpen(false);
    setName("");
    setDescription("");
    setUploadFile("");
    setSelectedRadio("");
    setSelectCategory("");
  };

  const item = {
    membership: name,
    price: price,
    discount: discount,
    calls: call,
    jobspost: post,
    validity: validity,
    role: userType,
    color: color,
    access: visibility,
  };

  async function SaveData() {
    const formData = new FormData();
    // Append each item to the FormData object
    for (const key in item) {
      if (item[key] !== undefined && item[key] !== null) {
        formData.append(key, item[key]);
      }
    }

    // let result = await fetch(
    //   "https://rptpl.roadpilot.co.in/public/api/addMemberShip",
    //   {
    //     method: "POST",
    //     body: formData,
    //   }
    // );

    // if (!result.ok) {
    //   throw new Error(`HTTP error! status: ${result.status}`);
    // }

    // const response = await result.json();

    showAlert("Added successfully", "success");
    handleAllData();
    getData();
  }
  const itemDetails = {
    status: statusType,
    approved_by: getUserInfo(),
    approved_at: format(new Date(), "yyyy-MM-dd HH:mm:ss 'UTC'"),
    note: descriptionRemark,
  };
  async function SaveRemark() {
    const formData = new FormData();
    // Append each item to the FormData object
    for (const key in itemDetails) {
      if (itemDetails[key] !== undefined && itemDetails[key] !== null) {
        formData.append(key, itemDetails[key]);
      }
    }
    try {
      await driverLeaveApis.remarkById(openMenuId, formData);

      showAlert("Updated successfully", "success");

      handleCloseRemark();
      getData();
    } catch {
      showAlert("Failed to update", "warning");
    }
  }
  // ends Here

  // Table Starts Here

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    try {
      const response = await driverLeaveApis.getAll();
      // Make sure response is an array before setting it
      if (Array.isArray(response.data)) {
        setArticalData(response.data);
      } else {
        console.error("API response is not an array:", response);
        setArticalData([]);
        showAlert("Invalid data format received", "error");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setArticalData([]);
      showAlert("Failed to load data", "error");
    }
  }

  const leaveStatus = (value) => {
    if (value === "0")
      return (
        <span style={{ color: "gray", fontSize: "15px" }}>On the way</span>
      );
    if (value === "1")
      return (
        <span style={{ color: "green", fontSize: "15px" }}>Successfully</span>
      );
    if (value === "2")
      return <span style={{ color: "red", fontSize: "15px" }}>Failed</span>;
    return "Unknown";
  };

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openDropMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const columns = [
    {
      name: "driver_id",
      label: "Operator's Name",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Operator's Name
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => {
          const ticketId = tableMeta.rowData[0];
          console.log(ticketId, tableMeta.rowData, "tabel data got");

          const fullRecord = articalData.find(
            (item) => item.driver_id === ticketId
          );

          if (!fullRecord) {
            return <div>Loading...</div>;
          }
          console.log(fullRecord, "all full record got");

          const imageUrl = `${config.apiImageUrl}${fullRecord.app_user_driver.image}`;

          return (
            <div
              key={value}
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src={imageUrl}
                alt="requester"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginRight: "10px",
                }}
              />
              <div>
                <div style={{ fontWeight: "bold" }}>
                  {fullRecord.app_user_driver.username || ""}
                </div>
                <div style={{ color: "gray" }}>{value || ""}</div>
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "owner_id",
      label: "Order By",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Order By
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => {
          const ticketId = tableMeta.rowData[1];

          const fullRecord = articalData.find(
            (item) => item.owner_id === ticketId
          );

          if (!fullRecord) {
            return <div>Loading...</div>;
          }

          const imageUrl = `${config.apiImageUrl}${fullRecord.owner.image}`;

          return (
            <div
              key={value}
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src={imageUrl}
                alt="requester"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginRight: "10px",
                }}
              />
              <div>
                <div style={{ fontWeight: "bold" }}>
                  {fullRecord.owner.username || ""}
                </div>
                <div style={{ color: "gray" }}>{value || ""}</div>
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "",
      label: "Pickup Point",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Pickup Point
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div>
                <div> {"Lucknow" || ""}</div>
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "created_at",
      label: " Date",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Date
            </th>
          );
        },
        customBodyRender: (value) => {
          const formattedDate = formatDate(value);
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {formattedDate}
            </div>
          );
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Status
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return (
            <td
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {leaveStatus(value)}
            </td>
          );
        },
      },
    },

    {
      name: "id",
      label: "Action",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "right",
                paddingRight: "70px",
                borderBottom: "1px solid #ddd",
              }}
            >
              Action
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => (
          <>
            <td
              key={value}
              style={{
                display: "flex",
                justifyContent: "flex-end", // Aligns content to the left
                alignItems: "center",
                paddingRight: "20px", // Add padding for starting point
              }}
            >
              <div style={{ paddingRight: "20px" }}>
                <Button
                  id="basic-button"
                  aria-controls={openDropMenu ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openDropMenu ? "true" : undefined}
                  onClick={handleClick}
                >
                  <div onClick={() => handleOpenMenu(value)}>
                    <MoreHorizTwoToneIcon />
                  </div>
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={openDropMenu}
                  onClose={handleCloseMenu}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={() => handleViewMore(tableMeta.rowData)}
                      style={{
                        display: "flex",
                        justifyContent: "space-center",
                        alignItems: "center",
                      }}
                    >
                      <RemoveRedEyeIcon /> View More
                    </div>
                  </MenuItem>
                  {/* <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={() => handleRemark()}
                      style={{
                        display: "flex",
                        justifyContent: "space-center",
                        alignItems: "center",
                      }}
                    >
                      <EditNoteIcon /> Remark
                    </div>
                  </MenuItem> */}
                </Menu>
              </div>
            </td>
          </>
        ),
      },
    },
  ];
  async function handleRemark() {
    handleUpdateDetails();
  }
  // Update Values Start
  const handleCloseRemark = () => {
    setOpenRemark(false);
    setStatusType([]);
    setDescriptionRemark("");
  };
  const options = {
    selectableRows: "none",
    selectToolbarPlacement: "none",
    responsive: "standard",
    elevation: 0,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [5, 10, 25, 100],
    onChangeRowsPerPage: (newRowsPerPage) => {
      setRowsPerPage(newRowsPerPage);
    },
    tableBody: {
      style: {
        maxHeight: `${rowsPerPage * 50}px`,
        overflow: "auto",
        marginLeft: "5px",
        transform: "translateZ(0)",
        backfaceVisibility: "hidden",
        boxShadow: "none",
      },
    },
    tableHead: {
      style: {
        backgroundColor: "#f2f2f2",
        color: "black",
      },
    },
    rows: {
      style: {
        marginLeft: "5px",
        textAlign: "center",
      },
      selectableRowsOnClick: true,
    },
  };

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
      tableBody: {
        style: {
          maxHeight: "500px",
          overflowY: "scroll",
        },
      },
      tableHead: {
        style: {
          backgroundColor: "#f2f2f2",
          color: "black",
        },
      },
      rows: {
        style: {
          "&:hover": {
            backgroundColor: "#f2f2f2",
          },
        },
      },
    });

  return (
    <>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />
      <HeaderCraneBooking />

      {/* Add Crane Booking Button */}
      <Box sx={{ p: 2, display: "flex", justifyContent: "flex-start" }}>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleOpenAddModal}
          sx={{
            backgroundColor: "#2196f3",
            "&:hover": {
              backgroundColor: "#1976d2",
            },
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          Add Crane Booking
        </Button>
      </Box>

      {/* Add Crane Booking Modal */}
      <Dialog
        fullWidth
        maxWidth="lg"
        open={openAddModal}
        onClose={handleCloseAddModal}
        TransitionComponent={TransitionRight}
        PaperProps={{
          style: {
            position: "fixed",
            right: 0,
            top: 0,
            bottom: 0,
            width: "75%",
            maxWidth: "75%",
            height: "100vh",
            margin: 0,
            maxHeight: "100vh",
            backgroundColor: "white",
            borderRadius: 0,
          },
        }}
      >
        <AppBar
          sx={{
            position: "relative",
            backgroundColor: "#f5f5f5",
            color: "#000",
          }}
        >
          <Toolbar>
            <Typography
              sx={{ ml: 2, flex: 1, color: "#000" }}
              variant="h6"
              component="div"
            >
              Add Crane Booking
            </Typography>
            <IconButton
              edge="end"
              sx={{ color: "#000" }}
              onClick={handleCloseAddModal}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>

        <Box
          sx={{
            p: 3,
            height: "calc(100vh - 64px)",
            overflow: "auto",
            backgroundColor: "#fafafa",
          }}
        >
          <Grid container spacing={3}>
            {/* Booking ID */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Booking ID"
                value={formData.booking_id}
                onChange={(e) =>
                  handleInputChange("booking_id", e.target.value)
                }
                variant="outlined"
                disabled
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#f5f5f5",
                    "& fieldset": {
                      borderColor: "#ccc",
                    },
                    "&:hover fieldset": {
                      borderColor: "#ccc",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#ccc",
                    },
                    "&.Mui-disabled": {
                      backgroundColor: "#f5f5f5",
                      "& fieldset": {
                        borderColor: "#e0e0e0",
                      },
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#666",
                    "&.Mui-disabled": {
                      color: "#999",
                    },
                  },
                  "& .MuiOutlinedInput-input": {
                    color: "#666",
                    "&.Mui-disabled": {
                      color: "#999",
                      WebkitTextFillColor: "#999",
                    },
                  },
                }}
              />
            </Grid>

            {/* User ID */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="User ID"
                value={formData.user_id}
                onChange={(e) => handleInputChange("user_id", e.target.value)}
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#fff",
                    "& fieldset": {
                      borderColor: "#666",
                    },
                    "&:hover fieldset": {
                      borderColor: "#333",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#2196f3",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#333",
                  },
                  "& .MuiOutlinedInput-input": {
                    color: "#000",
                  },
                }}
              />
            </Grid>

            {/* Crane Owner ID */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Crane Owner ID"
                value={formData.Crane_owner_id}
                onChange={(e) =>
                  handleInputChange("Crane_owner_id", e.target.value)
                }
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#fff",
                    "& fieldset": {
                      borderColor: "#666",
                    },
                    "&:hover fieldset": {
                      borderColor: "#333",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#2196f3",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#333",
                  },
                  "& .MuiOutlinedInput-input": {
                    color: "#000",
                  },
                }}
              />
            </Grid>

            {/* Trip ID */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Trip ID"
                value={formData.trip_id}
                onChange={(e) => handleInputChange("trip_id", e.target.value)}
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#fff",
                    "& fieldset": {
                      borderColor: "#666",
                    },
                    "&:hover fieldset": {
                      borderColor: "#333",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#2196f3",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#333",
                  },
                  "& .MuiOutlinedInput-input": {
                    color: "#000",
                  },
                }}
              />
            </Grid>

            {/* Driver Name */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Driver Name"
                value={formData.driver_name}
                onChange={(e) =>
                  handleInputChange("driver_name", e.target.value)
                }
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#fff",
                    "& fieldset": {
                      borderColor: "#666",
                    },
                    "&:hover fieldset": {
                      borderColor: "#333",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#2196f3",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#333",
                  },
                  "& .MuiOutlinedInput-input": {
                    color: "#000",
                  },
                }}
              />
            </Grid>

            {/* Driver Number */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Driver Number"
                value={formData.driver_number}
                onChange={(e) =>
                  handleInputChange("driver_number", e.target.value)
                }
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#fff",
                    "& fieldset": {
                      borderColor: "#666",
                    },
                    "&:hover fieldset": {
                      borderColor: "#333",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#2196f3",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#333",
                  },
                  "& .MuiOutlinedInput-input": {
                    color: "#000",
                  },
                }}
              />
            </Grid>

            {/* Vehicle ID */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Vehicle ID"
                value={formData.vehicle_id}
                onChange={(e) =>
                  handleInputChange("vehicle_id", e.target.value)
                }
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#fff",
                    "& fieldset": {
                      borderColor: "#666",
                    },
                    "&:hover fieldset": {
                      borderColor: "#333",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#2196f3",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#333",
                  },
                  "& .MuiOutlinedInput-input": {
                    color: "#000",
                  },
                }}
              />
            </Grid>

            {/* Latitude */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Latitude"
                type="number"
                value={formData.lat}
                onChange={(e) => handleInputChange("lat", e.target.value)}
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#fff",
                    "& fieldset": {
                      borderColor: "#666",
                    },
                    "&:hover fieldset": {
                      borderColor: "#333",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#2196f3",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#333",
                  },
                  "& .MuiOutlinedInput-input": {
                    color: "#000",
                  },
                }}
              />
            </Grid>

            {/* Longitude */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Longitude"
                type="number"
                value={formData.lng}
                onChange={(e) => handleInputChange("lng", e.target.value)}
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#fff",
                    "& fieldset": {
                      borderColor: "#666",
                    },
                    "&:hover fieldset": {
                      borderColor: "#333",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#2196f3",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#333",
                  },
                  "& .MuiOutlinedInput-input": {
                    color: "#000",
                  },
                }}
              />
            </Grid>

            {/* Distance */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Distance"
                type="number"
                value={formData.distance}
                onChange={(e) => handleInputChange("distance", e.target.value)}
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#fff",
                    "& fieldset": {
                      borderColor: "#666",
                    },
                    "&:hover fieldset": {
                      borderColor: "#333",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#2196f3",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#333",
                  },
                  "& .MuiOutlinedInput-input": {
                    color: "#000",
                  },
                }}
              />
            </Grid>

            {/* Total Amount */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Total Amount"
                type="number"
                value={formData.total_amount}
                onChange={(e) =>
                  handleInputChange("total_amount", e.target.value)
                }
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#fff",
                    "& fieldset": {
                      borderColor: "#666",
                    },
                    "&:hover fieldset": {
                      borderColor: "#333",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#2196f3",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#333",
                  },
                  "& .MuiOutlinedInput-input": {
                    color: "#000",
                  },
                }}
              />
            </Grid>

            {/* First Payment */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="First Payment"
                type="number"
                value={formData.first_payment}
                onChange={(e) =>
                  handleInputChange("first_payment", e.target.value)
                }
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#fff",
                    "& fieldset": {
                      borderColor: "#666",
                    },
                    "&:hover fieldset": {
                      borderColor: "#333",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#2196f3",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#333",
                  },
                  "& .MuiOutlinedInput-input": {
                    color: "#000",
                  },
                }}
              />
            </Grid>

            {/* First Payment Time */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="First Payment Time"
                type="datetime-local"
                value={formData.first_payment_time}
                onChange={(e) =>
                  handleInputChange("first_payment_time", e.target.value)
                }
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#fff",
                    "& fieldset": {
                      borderColor: "#666",
                    },
                    "&:hover fieldset": {
                      borderColor: "#333",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#2196f3",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#333",
                  },
                  "& .MuiOutlinedInput-input": {
                    color: "#000",
                  },
                }}
              />
            </Grid>

            {/* Booking Status */}
            <Grid item xs={12} sm={6}>
              <Select
                fullWidth
                value={formData.booking_status}
                onChange={(e) =>
                  handleInputChange("booking_status", e.target.value)
                }
                displayEmpty
                variant="outlined"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      backgroundColor: "#fff",
                      "& .MuiMenuItem-root": {
                        backgroundColor: "#fff",
                        color: "#000",
                        "&:hover": {
                          backgroundColor: "#f5f5f5",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#e3f2fd",
                          "&:hover": {
                            backgroundColor: "#bbdefb",
                          },
                        },
                      },
                    },
                  },
                }}
                sx={{
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#666",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#333",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#2196f3",
                  },
                  "& .MuiSelect-select": {
                    color: "#000",
                  },
                  "& .MuiInputLabel-root": {
                    color: "#333",
                  },
                }}
              >
                <MenuItem value="">
                  <em style={{ color: "#666" }}>Select Booking Status</em>
                </MenuItem>
                <MenuItem value="0">Pending</MenuItem>
                <MenuItem value="1">Confirmed</MenuItem>
                <MenuItem value="2">In Progress</MenuItem>
                <MenuItem value="3">Completed</MenuItem>
                <MenuItem value="4">Cancelled</MenuItem>
              </Select>
            </Grid>

            {/* Address */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Address"
                multiline
                rows={2}
                value={formData.address}
                onChange={(e) => handleInputChange("address", e.target.value)}
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#fff",
                    "& fieldset": {
                      borderColor: "#666",
                    },
                    "&:hover fieldset": {
                      borderColor: "#333",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#2196f3",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#333",
                  },
                  "& .MuiOutlinedInput-input": {
                    color: "#000",
                  },
                }}
              />
            </Grid>

            {/* Note */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Note"
                multiline
                rows={3}
                value={formData.note}
                onChange={(e) => handleInputChange("note", e.target.value)}
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#fff",
                    "& fieldset": {
                      borderColor: "#666",
                    },
                    "&:hover fieldset": {
                      borderColor: "#333",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#2196f3",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#333",
                  },
                  "& .MuiOutlinedInput-input": {
                    color: "#000",
                  },
                }}
              />
            </Grid>

            {/* Action Buttons */}
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  justifyContent: "flex-end",
                  mt: 2,
                }}
              >
                <Button
                  variant="outlined"
                  onClick={handleCloseAddModal}
                  sx={{
                    textTransform: "none",
                    color: "#333",
                    borderColor: "#666",
                    "&:hover": {
                      borderColor: "#333",
                      backgroundColor: "#f5f5f5",
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={handleSubmitCraneBooking}
                  sx={{
                    backgroundColor: "#2196f3",
                    "&:hover": {
                      backgroundColor: "#1976d2",
                    },
                    textTransform: "none",
                  }}
                >
                  Save Crane Booking
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
      <Dialog
        fullWidth
        maxWidth="md"
        open={openRemark}
        onClose={handleCloseRemark}
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            position: "absolute",
            background: "#141b2d",
            top: "0",
            backgroundColor: "white",
            maxHeight: "95%",
            margin: "auto",
            overflowX: "hidden",
            zIndex: 1200,
          },
        }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseRemark}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} component="div">
              Add Remark
            </Typography>
          </Toolbar>
        </AppBar>

        <Box sx={{ background: "#fff" }}>
          <Grid
            container
            spacing={4}
            style={{ color: "black", padding: "20px" }}
          >
            <Grid item xs={11} sm={4} md={3}>
              <Stack direction="column">
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Status
                </Typography>
                <Select
                  value={statusType}
                  autoFocus
                  onChange={(e) => setStatusType(parseInt(e.target.value, 10))}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  sx={{
                    border: "1px solid black",
                    boxSizing: "border-box",
                    "& .MuiOutlinedInput-root": {
                      borderColor: "black !important",
                      "&:hover fieldset": {
                        borderColor: "black !important",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "black !important",
                      },
                    },
                    color: "black",
                  }}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return (
                        <span style={{ color: "gray" }}>
                          Select Status Type
                        </span>
                      );
                    }
                    if (selected === 0) {
                      return "Rejected";
                    }
                    if (selected === 2) {
                      return "Approved";
                    }
                    return "Unknown";
                    // return selected === 0 ? "Rejected" : "Approved";
                  }}
                >
                  <MenuItem value={0}>Rejected</MenuItem>
                  <MenuItem value={2}>Approved</MenuItem>
                </Select>
              </Stack>
            </Grid>
            <Grid item xs={11} sm={7.5} md={8.5}>
              <Stack direction="column" sx={{ width: "100%" }}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Remark<span style={{ color: "red" }}>*</span>
                </Typography>

                <ReactQuill
                  value={descriptionRemark}
                  onChange={setDescriptionRemark}
                  modules={modules}
                  theme="snow"
                  style={{
                    width: "100%",
                    height: "70px",
                    boxSizing: "border-box",
                    color: "black",
                    borderBlockColor: "black",
                  }}
                />
              </Stack>
            </Grid>
          </Grid>

          <Grid container sx={{ padding: "50px 0 30px 20px" }}>
            <Grid item xs={11} className="messageFooter">
              <Box className="response" onClick={SaveRemark}>
                Save
              </Box>
              <Box className="cancel" onClick={handleCloseRemark}>
                Cancel
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Dialog>

      <Divider />
      <ListItemText style={{ background: "white", margin: 0 }}>
        <ThemeProvider theme={getTheme()}>
          <Box
            sx={{
              maxWidth: "100%",
            }}
          >
            <MUIDataTable
              title={
                <span
                  style={{
                    fontWeight: 700,
                    fontSize: "1.5rem",
                    color: "#333",
                  }}
                >
                  Crane Booking
                </span>
              }
              data={articalData || []}
              columns={columns}
              options={options}
            />
          </Box>
        </ThemeProvider>
      </ListItemText>
    </>
  );
}

export default CraneBooking;
